module.exports = __webpack_public_path__ + "img/dierenkliniek_den_ham.111c8a94.png";